import React from 'react';
import { Button } from '@/components/ui/button';
import { User } from 'lucide-react';

export default function HeroSection({ onLoginClick }) {
  // Background image applied inline so webpack doesn't try to bundle the public-folder asset
  const heroBg = {
    backgroundImage: [
      'linear-gradient(to right, rgba(0,20,60,0.82) 0%, rgba(0,20,60,0.52) 55%, rgba(0,20,60,0.72) 100%)',
      'linear-gradient(to top, rgba(255,107,0,0.25) 0%, transparent 50%)',
      "url('/images/courtview2_clean.jpeg')",
    ].join(', '),
  };

  return (
    <div className="bba-hero overflow-hidden" style={heroBg}>

      {/* Courtview1 — left-side luminosity accent (hidden on mobile via CSS) */}
      <div
        aria-hidden="true"
        className="bba-hero-crowd-overlay"
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: "url('/images/courtview1.jpeg')",
          backgroundSize: 'cover',
          backgroundPosition: 'right center',
          mixBlendMode: 'luminosity',
          opacity: 0.30,
          clipPath: 'inset(0 45% 0 0)',
          pointerEvents: 'none',
          zIndex: 1,
        }}
      />

      {/* Content */}
      <div
        className="relative flex flex-col justify-center items-center text-center"
        style={{
          minHeight: 'inherit',
          padding: 'clamp(1.5rem, 5vw, 3rem) 1rem',
          /* Top padding includes the notch/status-bar height so the logo
             is never hidden behind the Dynamic Island on iOS.             */
          paddingTop: 'calc(clamp(1.5rem, 5vw, 3rem) + env(safe-area-inset-top, 0px))',
          paddingBottom: 'calc(clamp(1.5rem, 5vw, 3rem) + env(safe-area-inset-bottom, 0px))',
          zIndex: 2,
        }}
      >
        {/* Logo */}
        <div className="mb-5 sm:mb-7">
          <img
            src="/images/bba-logo.jpg"
            alt="Brunei Basketball Association"
            style={{
              width: 'clamp(100px, 18vw, 130px)',
              height: 'clamp(100px, 18vw, 130px)',
              borderRadius: '50%',
              border: '4px solid rgba(255,255,255,0.9)',
              objectFit: 'cover',
              display: 'block',
              margin: '0 auto',
              filter: 'drop-shadow(0 0 12px rgba(255,255,255,0.4))',
              boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
            }}
          />
        </div>

        {/* Title */}
        <h1
          className="font-black font-heading uppercase text-white tracking-tight drop-shadow-lg mb-2"
          style={{ fontSize: 'clamp(26px, 4.5vw, 48px)', lineHeight: 1.1, maxWidth: '700px' }}
        >
          Brunei Basketball Association
        </h1>

        {/* Tagline */}
        <p
          className="font-semibold text-orange-300 drop-shadow-md mb-3"
          style={{ fontSize: 'clamp(15px, 2.2vw, 22px)' }}
        >
          Find. Book. Play.
        </p>

        {/* Subtitle */}
        <p className="text-white/85 mb-8 max-w-xl" style={{ fontSize: 'clamp(13px, 1.5vw, 16px)' }}>
          Reserve your basketball court in under 60 seconds.
        </p>

        {/* CTA Button */}
        <div className="w-full flex justify-center px-4 sm:px-0">
          <Button
            onClick={onLoginClick}
            data-testid="login-button"
            className="bg-white text-blue-800 hover:bg-blue-50 font-bold shadow-2xl w-full sm:w-auto"
            style={{
              maxWidth: '320px',
              minHeight: '52px',
              fontSize: 'clamp(15px, 1.8vw, 18px)',
              paddingLeft: '2rem',
              paddingRight: '2rem',
            }}
          >
            <User className="w-5 h-5 mr-2 flex-shrink-0" />
            Login / Sign Up
          </Button>
        </div>
      </div>
    </div>
  );
}

